import React from 'react';
import classNames from 'classnames';
import '../../../assests/css/textinput.scss';

export interface textInputProps {
    type: 'text' | 'textarea',
    text: string,
    placeholder: string,
    onChange: (text: string)=> void,
    rows?: number,
    cols?: number,
    style?: object,
    className?: string,
}

export default function TextInput(props: textInputProps) {

    const {type, text, placeholder, rows, cols, style, className} = props;

    const onHandleChange = (e: React.ChangeEvent<HTMLInputElement |
        HTMLTextAreaElement>) => {
        props.onChange(e.target.value);
    }

    return (
        <div className="text-input-container">
            {type === 'text'?
                <input className={classNames('text-input', className? className: '')}
                    type="text" placeholder={props.placeholder}
                    onChange={(e)=> onHandleChange(e)}
                    value={text} style={style}>
                </input>:
                <textarea className={classNames('textarea-input', className? className: '')}
                    rows={rows} cols={cols} placeholder={placeholder}
                    onChange={(e)=> onHandleChange(e)}     
                    value={text}></textarea>
            }
        </div>
    );

} 